import { useState } from "react";

export default function useUniqueId(): string {
    // eslint-disable-next-line @eslint-react/naming-convention/use-state -- we don't need setId here, just using state to store a value
    const [id] = useState(crypto.randomUUID())
    return id;
}